<template>
  <lemon-imui ref="IMUI" @send="handleSend" @pull-messages="handlePullMessages">
    <!-- <template #cover>
          <div class="cover">
            <i class="lemon-icon-message"></i>
            <p><b>自定义封面 Lemon</b> IMUI</p>
          </div>
        </template> -->
  </lemon-imui>
</template>


<script>
import EmojiData from "../../../static/js/emoji.js";
//var ws = new WebSocket("ws://localhost:8000/api/system/auth/ws/123")
export default {
  data() {
    return {

    }
  },
  mounted() {

    // const { IMUI } = this.$refs;
    // //IMUI.width = 200; //设置窗口宽度
    // //IMUI.height = 200; //设置窗口高度
    // IMUI.user = { id: "1100", displayName: "测试", avatar: "https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fcdn.duitang.com%2Fuploads%2Fitem%2F201410%2F08%2F20141008210803_Kxjhf.thumb.700_0.jpeg&refer=http%3A%2F%2Fcdn.duitang.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1617419850&t=2383ea743db818f0eb5d4233b7aaf5b2" }
    // //IMUI.theme = 'blue' //设置主题
    // IMUI.avatarCricle = true  //使用圆形头像
    // //IMUI.simple = true


    // //接收消息
    // ws.onmessage = function (event) {
    //   //将接收到的数据包装成下面的样子
    //   const data = {
    //     id: '123123123',
    //     status: 'succeed',
    //     type: 'text',
    //     sendTime: 1566047865417,
    //     content: event.data,
    //     toContactId: 1100,
    //     fromUser: {
    //       //如果 id == this.user.id消息会显示在右侧，否则在左侧
    //       id: 1200,
    //       displayName: '盛佳杰',
    //       avatar: '',
    //     }
    //   };
    //   IMUI.appendMessage(data);
    // };


    // //联系人数据
    // const contactData3 = {
    //   id: "1100",   //唯一ID
    //   displayName: "胡宏达",  //名称
    //   avatar: "http://upload.qqbodys.com/img/weixin/20170803/jiq4nzrkrnd0e.jpg",  //头像 url
    //   index: "T",  //通讯录索引
    //   unread: 32,   //未读消息条数
    //   lastSendTime: 1614833746000,  //最近一条消息的时间戳，13位毫秒
    //   lastContent: "你好123",   //最后发送内容
    // };

    // const contactData4 = {
    //   id: "1200",
    //   displayName: "盛佳杰",
    //   avatar:
    //     "https://dss2.bdstatic.com/70cFvnSh_Q1YnxGkpoWK1HF6hhy/it/u=4275424924,2201401076&fm=111&gp=0.jpg",
    //   index: "R",
    //   unread: 1,
    //   lastSendTime: 3,
    //   lastContent: "吃饭了嘛",
    // };
    // //联系人列表
    // let contactList = [
    //   { ...contactData3 }, { ...contactData4 }

    // ];
    // //初始化联系人
    // IMUI.initContacts(contactList);

    // //菜单数据
    // const cd1 = [{
    //   name: "messages",
    // },
    // {
    //   name: "contacts",
    // },

    // {
    //   name: "custom1",
    //   title: "自定义按钮1",
    //   unread: 0,
    //   render: menu => {
    //     return <i class="lemon-icon-attah" />;
    //   },
    //   renderContainer: () => {
    //     return (
    //       <div class="article">
    //         <ul>
    //           <li class="article-item">
    //             <h2>人民日报谈网红带货：产品真的值得买吗？</h2>
    //           </li>
    //           <li class="article-item">
    //             甘肃夏河县发生5.7级地震 暂未接到人员伤亡报告
    //             </li>
    //           <li class="article-item">
    //             北方多地风力仍强沙尘相伴,东北内蒙古等地迎雨雪
    //             </li>
    //           <li class="article-item">
    //             英货车案：越南警方采集疑死者家属DNA作比对
    //             </li>
    //           <li class="article-item">
    //             知名连锁咖啡店的蛋糕吃出活虫 曝光内幕太震惊
    //             </li>
    //         </ul>
    //         <lemon-contact
    //           props={{ contact: contactData3 }}
    //           style="margin:20px"
    //         />
    //         <lemon-contact
    //           props={{ contact: contactData4 }}
    //           style="margin:20px"
    //         />
    //       </div>
    //     );
    //   },
    //   isBottom: true,
    // },
    // {
    //   name: "custom2",
    //   title: "自定义按钮2",
    //   unread: 0,
    //   click: () => {
    //     alert("拦截导航点击事件");
    //   },
    //   render: menu => {
    //     return <i class="lemon-icon-group" />;
    //   },
    //   isBottom: true,
    // },
    // ]

    // IMUI.initMenus(cd1)

    // //切换到聊天窗口
    // //IMUI.changeContact("contact-3")

    // //初始化聊天窗口工具栏
    // IMUI.initEditorTools([
    //   {
    //     name: "emoji",
    //   }, {
    //     name: "uploadFile",
    //   },
    //   {
    //     name: "uploadImage",
    //   },])
    // //初始化表情数据
    // IMUI.initEmoji(EmojiData);
  },
  methods: {
    //获取消息
    // handlePullMessages(contact, next) {
    //   //从后端请求消息数据，包装成下面的样子
    //   const messages = [{
    //     id: '唯一消息ID',
    //     status: 'succeed',
    //     type: 'text',
    //     sendTime: 1566047865417,
    //     content: '你什么才能对接完？',
    //     toContactId: 1200,
    //     fromUser: 1100
    //   }]
    //   //将第二个参数设为true，表示已到末尾，聊天窗口顶部会显示“暂无更多消息”，不然会一直转圈。
    //   next(messages, true);
    //},
    //发送消息
    // handleSend(message, next, file) {
    //   console.log(message, next, file);
    //   setTimeout(() => {
    //     console.log(message)
    //     ws.send(message.content)
    //     next();
    //   }, 1000);
    // },
  }
}
</script>
<style scoped>
.conver {
  text-align: center;
  user-select: none;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.conver i {
  font-size: 84px;
  color: #e6e6e6;
}

.conver i {
  font-size: 18px;
  color: #ddd;
  line-height: 50px;
}
</style>


// WEBPACK FOOTER //
// src/view/ltgl/lt.vue